/* OSKA_LANG_AUTO_20261018
   - window.OSKA_LOCALES: yayindaki diller ve adresleri (theme.liquid Liquid ile yazar)
   - Ilk giriste ulkeye / tarayici diline gore otomatik dil (yalnizca yayindaki dillere)
   - Elle secilen dil hatirlanir, bir daha otomatik degistirilmez
   - Dil asistanindaki butonlar: dil yayindaysa siteyi o dile cevirir */
(function () {
  var D = window.OSKA_LOCALES || { primary: 'tr', current: 'tr', country: '', list: {} };
  var LIST = D.list || {};
  var KEY = 'oska_lang_choice';

  function norm(c) {
    c = String(c || '').toLowerCase();
    if (c.indexOf('zh') === 0) return 'zh-CN';
    return c.split('-')[0];
  }
  function published(c) { return Object.prototype.hasOwnProperty.call(LIST, norm(c)); }
  window.oskaLocaleOn = published;

  function get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  var COUNTRY = {
    TR: 'tr', CY: 'tr',
    DE: 'de', AT: 'de', CH: 'de', LI: 'de',
    RU: 'ru', BY: 'ru', KZ: 'ru', KG: 'ru',
    AE: 'ar', SA: 'ar', QA: 'ar', KW: 'ar', BH: 'ar', OM: 'ar', EG: 'ar', JO: 'ar', LB: 'ar', IQ: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', LY: 'ar',
    ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es', EC: 'es', UY: 'es', PY: 'es', BO: 'es', CR: 'es', PA: 'es', DO: 'es', GT: 'es',
    FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr', SN: 'fr', CI: 'fr',
    CN: 'zh-CN', TW: 'zh-CN', HK: 'zh-CN', SG: 'zh-CN', MO: 'zh-CN'
  };

  function browserLang() {
    var l = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    for (var i = 0; i < l.length; i++) { var c = norm(l[i]); if (c) return c; }
    return '';
  }

  function wanted() {
    var b = browserLang();
    if (b === 'tr') return 'tr';                       // Turkce konusan herkes Turkce kalir
    var c = COUNTRY[String(D.country || '').toUpperCase()];
    if (c && c !== 'tr' && published(c)) return c;      // once ulke
    if (b && published(b)) return b;                    // sonra tarayici dili
    if (published('en')) return 'en';                   // yabanci ziyaretci: Ingilizce
    return '';
  }

  function isBot() {
    return navigator.webdriver || /bot|crawl|spider|slurp|facebookexternalhit|preview|lighthouse/i.test(navigator.userAgent || '');
  }

  function urlFor(code) {
    var root = LIST[code];
    if (root == null) return null;
    var cur = LIST[norm(D.current)] || '/';
    var path = location.pathname;
    if (cur !== '/' && path.indexOf(cur) === 0) path = path.slice(cur.length) || '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var base = root === '/' ? '' : root.replace(/\/$/, '');
    return (base + path).replace(/\/{2,}/g, '/') + location.search + location.hash;
  }

  // 1) Otomatik dil: yalnizca ilk ziyaret, elle secim yoksa
  try {
    var g = get() || '';
    if (g.indexOf('m:') !== 0 && !isBot()) {
      var w = wanted();
      if (w && g !== 'a:' + w) set('a:' + w);
      if (w && g !== 'a:' + w && w !== norm(D.current)) {
        var u = urlFor(w);
        if (u && u !== location.pathname + location.search + location.hash) { location.replace(u); return; }
      }
    }
  } catch (e) {}

  // 2) Elle secim hatirlanir (header dil menusu)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="language_code"]');
    if (b) set('m:' + norm(b.value));
  }, true);

  // 3) Dil asistani: yayindaki dile tiklayinca siteyi o dile cevir (canli sohbet yerine)
  function go(code) {
    code = norm(code);
    if (!published(code)) return false;
    set('m:' + code);
    var btn = document.querySelector('.oska-language-direct button[name="language_code"][value="' + code + '"]');
    if (btn) { btn.click(); return true; }
    var u = urlFor(code);
    if (u) { location.href = u; return true; }
    return false;
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.oska-language-quick [data-oska-language-code]');
    if (!b) return;
    var code = b.dataset.oskaLanguageCode;
    if (published(code)) {
      e.preventDefault(); e.stopImmediatePropagation();
      try { if (window.speechSynthesis) speechSynthesis.cancel(); } catch (x) {}
      var st = document.querySelector('[data-oska-language-status]');
      if (st) st.textContent = (b.textContent || code).split(' ')[0] + ' …';
      go(code);
    }
  }, true);

  // 4) Yayindaki dillerin butonlarindaki "yakinda / canli asistan" etiketini temizle
  var NAMES = { tr: 'TR · Türkçe', en: 'EN · English', ru: 'RU · Русский', ar: 'AR · العربية', de: 'DE · Deutsch', es: 'ES · Español', fr: 'FR · Français', zh: 'ZH · 中文' };
  function tidy() {
    document.querySelectorAll('.oska-language-quick').forEach(function (box) {
      Object.keys(NAMES).forEach(function (c) {
        if (!published(c) || box.querySelector('[data-oska-language-code="' + c + '"]')) return;
        var b = document.createElement('button');
        b.type = 'button'; b.dataset.oskaLanguageCode = c; b.textContent = NAMES[c];
        if (c === 'ar') { b.lang = 'ar'; b.dir = 'rtl'; }
        box.appendChild(b);
      });
    });
    document.querySelectorAll('.oska-language-quick [data-oska-language-code]').forEach(function (b) {
      var c = b.dataset.oskaLanguageCode;
      var on = published(c);
      b.classList.toggle('is-live', on);
      if (on) { b.removeAttribute('aria-disabled'); var s = b.querySelector('small'); if (s) s.remove(); }
      if (norm(c) === norm(D.current)) b.setAttribute('aria-current', 'true');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tidy(); setTimeout(tidy, 800); });
  else { tidy(); setTimeout(tidy, 800); }
})();

/* OSKA_LANG_MOBILE_20261019: telefon ve tablette dil asistani paneline ulasilamiyordu (panel bilgisayar menusunun icindeydi).
   Telefonda/tablette ustteki dil butonu (TR) artik dil asistanini acar; panel ekranin altinda kart olarak cikar. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width:1050px)') : { matches: false };
  var css = '.oska-lp--sheet{position:fixed!important;left:12px!important;right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom))!important;top:auto!important;width:auto!important;max-width:520px!important;margin:0 auto!important;max-height:82vh!important;overflow:auto!important;z-index:2147483000!important;transform:none!important}' +
    '.oska-lp--sheet[hidden]{display:none!important}';
  function setup() {
    var panel = document.querySelector('[data-oska-language-panel]');
    if (!panel) return;
    if (!document.getElementById('oska-lp-sheet-css')) { var st = document.createElement('style'); st.id = 'oska-lp-sheet-css'; st.textContent = css; document.head.appendChild(st); }
    function apply() {
      if (mq.matches) {
        if (panel.parentNode !== document.body) document.body.appendChild(panel);
        panel.classList.add('oska-lp--sheet');
        document.querySelectorAll('.oska-mobile-head .oska-language-current').forEach(function (b) {
          b.removeAttribute('data-oska-language-current');
          b.setAttribute('data-oska-language-assistant', '');
          b.setAttribute('aria-controls', 'OskaLanguageAssistant');
        });
      } else {
        panel.classList.remove('oska-lp--sheet');
      }
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
